import React, { Component } from 'react';
import { Modal, Button, Icon, message } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import Text from '../../../basicElement/Text';
import FormList from '../../../basicElement/FormList';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';

class Transfer extends Component {
    state = {
        visible: false,
        loading: false,
        user: {},
        data: {},
    }

    show = (user) => {
        this.setState({
            user,
            data: {},
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { record, type } = this.props;
        const { user, data } = this.state;
        const { customerCompanyId } = record;
        const { userId, userCompellation } = user;
        const { handOverUserId, handOverUserCompellation } = data;

        if (!handOverUserId) {
            Modal.error({ title: "请选择交接人" })
            return;
        }
        Modal.confirm({
			title: `确定由“${handOverUserCompellation}”接手“${userCompellation}”在此客户上的${type}工作?`,
            onOk: () => {
                this.setState({ loading: true });
                let url;
                if (type == 'BA') {
                    url = API_URL.contract.handoverCustomerBaList;
                }else{
                    url = API_URL.contract.handoverBaUserList;
                }
                Fetch.post(url, {
                    userId,
                    'baHandOvers[0].handOverUserId': handOverUserId,
                    'baHandOvers[0].customerCompanyIdList': customerCompanyId,
                }).then(() => {
                    message.success('交接成功');
                    this.setState({
                        loading: false,
                    }, () => {
                        this.hide();
                        this.props.loadData();
                    });
                }).catch(err => {
                    console.error(err);
                    this.setState({ loading: false });
                });
            }
        });
    }

    handleChange = ({ text, value, userCompellation }) => {
        const { data } = this.state;
        data.handOverUserId  = value;
        data.handOverUserName = text;
        data.handOverUserCompellation = userCompellation;
        this.setState({ data });
    }

    render() {
        const { record, type } = this.props;
        const { visible, loading, user, data } = this.state;
        const { handOverUserName } = data;
        const { userCompellation, employeeCode, userId } = user;
        const { customerCompanyName, customerCompanyCode } = record;
        return (
            <Modal
                title={`交接${type}`}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                loading={loading}
                maskClosable={false}
                width="400px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">客户名称:</div>
                            <div className="item-right">
                                {customerCompanyName}
                            </div>
                        </li>
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">客户代码:</div>
                            <div className="item-right">
                                {customerCompanyCode}
                            </div>
                        </li>
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">{type}:</div>
                            <div className="item-right">
                                {userCompellation}[{employeeCode}]
                            </div>
                        </li>
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                                <div className="item-left"><Text asterisk={true}>工作交接给</Text>:</div>
                                <div className="item-right">
                                    {
                                        <SearchRetrieve
                                            keyword='keyWord'
                                            style={{ width: 160, marginBottom: 10 }}
                                            value={handOverUserName}
                                            params={{ limit: 20, roleCodes: type == 'BA'?'BA,BAL':'CSA,CSAL', filterSelf: 1, selfUserId: userId }}
                                            placeholder="输入姓名/工号检索"
                                            url={API_URL.execute.queryEmpListByRoleCode}
                                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                            onChange={this.handleChange}
                                        />
                                    }
                                </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

class ConfigBa extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        list: [],
        record: {},
        type: '',
    }

    loadData = () => {
        const { record, type } = this.state;
        const { customerCompanyId } = record;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryCustomerCompanyBaList, {
            customerCompanyId,
        }).then(res => {
            const { datas } = res;
            this.setState({
                loading: false,
                list: type=='BA' ? ((datas || [])[0] || {}).baList:((datas || [])[0] || {}).csaList,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record, type) => {
        this.setState({
            record,
            type,
            data: [],
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        const { value: userId, text: userName } = value;
        data.userId = userId;
        data.userName = userName;
        this.setState({ data });
    }

    getColumns = () => {
        const { data, record, type } = this.state;

        // 字段属性配置
        const columns = [{
            name: '客户名称',
            key: 'customerCompanyName',
            type: 'text',
        }, {
            name: '客户代码',
            key: 'customerCompanyCode',
            type: 'text',
        }, {
            name: type,
            key: 'userName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyWord',
                style: { width: 200 },
                placeholder: '输入姓名/工号检索',
                params: { limit: 20, roleCodes: type == 'BA'?'BA,BAL':'CSA,CSAL' },
                url: API_URL.execute.queryEmpListByRoleCode,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            },
            suffix: <Button type="primary" style={{ marginLeft: 10 }} onClick={this.confirm}>添加</Button>,
            rules: {
                required: true,
            },
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    if (type === 'text') {
                        typeProperty.value = record[key];
                    } else {
                        typeProperty.value = data[key];
                    }
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    fetchData = () => {
        this.loadData();
        this.props.loadData();
    }

    delete = (customerCompanyCsaId, userId, customerCompanyId) => {
        const { data, type } = this.state;
        Modal.confirm({
			title: `确定删除该${type}人员？`,
            onOk: () => {
                this.setState({ loading: true });
                let url;
                if (type == 'BA') {
                    url = API_URL.contract.delCustomerCompanyBa;
                }else{
                    url = API_URL.contract.deleteCustomerCompanyCsa;
                }
				Fetch.post(url, {
                    customerCompanyCsaId,
                    customerCompanyId,
                    userId,
                }).then(res => {
                    const { success } = res;
                    message.success(success);
                    this.setState({ loading: false }, this.fetchData);
                }).catch(err => {
                    console.error(err);
                });
            }
        });
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data, record, type } = this.state;
        const { userId } = data;
        const { customerCompanyId } = record;
        this.setState({ loading: true });
        let url;
        if (type == 'BA') {
            url = API_URL.contract.addCustomerCompanyBa;
        }else{
            url = API_URL.contract.configCustomerCompanyBa;
        }
        Fetch.post(url, {
            customerCompanyId,
            userId,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({
                data: {},
                loading: false,
            }, this.fetchData);
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getContent = () => {
        const { list } = this.state;
        const result = (list || []).map((item, index) => {
            const { customerCompanyBaId, customerCompanyCsaId, userCompellation, employeeCode, userId, customerCompanyId } = item;
            const content = `${userCompellation}[${employeeCode}]`;
            return (
                <li
                    key={customerCompanyBaId}
                    className="select-item"
                    style={{ position: 'relative', marginTop: 4 }}
                >
                    {content}
                    <Icon
                        onClick={() => this.delete(customerCompanyCsaId, userId, customerCompanyId)}
                        type="close-circle"
                        style={{ position: 'absolute', fontSize: '16px', color: '#5750C9', top: 2, right: 24, cursor: "pointer" }}
                    />
                    <div style={{ display: 'inline-block', position: 'absolute', top: 2, right: 0, color: "#fff", cursor: "pointer", backgroundColor: "#fdaf32", borderRadius: 8, width: 16, height: 16, lineHeight: "16px", textAlign: "center" }}>
                        <i onClick={() => this.transfer(item)} style={{ fontSize: "12px" }} className="icon iconfont">&#xe62a;</i>
                    </div>
                </li>
            );
        });
        return (
            <ul style={{ marginLeft: '25%', paddingLeft: 6, width: 206 }}>
                { result }
            </ul>
        );
    }

    transfer = (user) => {
        this.transferRef.show(user);
    }

    render() {
        const { visible, record, type } = this.state;
        return (
            <Modal
                title={`配置${type}`}
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="460px"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <FormList
                    className="form-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
                { this.getContent() }
                <Transfer ref={el => this.transferRef = el} record={record} loadData={this.fetchData} type={type} />
            </Modal>
        );
    }
}

export default ConfigBa;


// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/ConfigBa.js